import axios from 'axios';
import { getApiUrl } from '../utils/appConfig';

// --------------------------------------------------------
// Use centralized baseURL configuration
// This uses window.APP_CONFIG.REACT_APP_API_URL from config.js (runtime configuration)
export const API = axios.create({ baseURL: getApiUrl() })

API.interceptors.request.use(req => {
    const token = window.localStorage.getItem('accessToken');
    if (token) {
        req.headers.Authorization = `Token ${token}`;
    }
    return req
})



// request interceptor (just attach token, no expiry check)
// API.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem("accessToken");
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // response interceptor (handle 401 and refresh)
// API.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         if (
//             error.response?.status === 401 &&
//             !originalRequest._retry &&
//             !originalRequest.url.includes("/auth/refresh")
//         ) {
//             originalRequest._retry = true;

//             try {
//                 const res = await axios.post("https://your-api.com/auth/refresh", {
//                     refreshToken: localStorage.getItem("refreshToken"),
//                 });

//                 const newAccessToken = res.data.accessToken;
//                 localStorage.setItem("accessToken", newAccessToken);

//                 originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//                 return axiosInstance(originalRequest);
//             } catch (err) {
//                 localStorage.removeItem("accessToken");
//                 localStorage.removeItem("refreshToken");
//                 window.location.href = "/login";
//                 return Promise.reject(err);
//             }
//         }

//         return Promise.reject(error);
//     }
// );
